// ** MUI Imports
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';

// ** Theme Config
import themeConfig from 'src/configs/themeConfig';

// ** Direction component for LTR or RTL
import Direction from 'src/layouts/components/Direction';
// ** Global Styles
import GlobalStyling from './globalStyles';
// ** Theme
import themeOptions from './ThemeOptions';

const ThemeComponent = (props) => {
  // ** Props
  const { settings, children } = props;

  // ** Pass merged ThemeOptions (of core and user) to createTheme function
  let theme = createTheme(themeOptions(settings, 'light'));

  // ** Set responsive font sizes to true
  if (themeConfig.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Direction direction={settings.direction}>
          <CssBaseline />
          <GlobalStyles styles={() => GlobalStyling(theme)} />
          {children}
        </Direction>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeComponent;
